import { useRef, useState, useEffect } from "react";
import { Typography } from "@mui/material";
import CustomTooltip from "./CustomTooltip";

const OverflowTooltip = ({
  children,
  sx = {},
  placement = "top",
  variant = null,
  component = null,
  onClick = () => null,
}) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isOverflowing = el.scrollWidth > el.clientWidth;
      setShowTooltip(isOverflowing);
    }
  }, [children]);

  return (
    <CustomTooltip
    placement={placement}
      title={showTooltip ? (typeof children === "string" ? children : "") : ""}
    >
      <Typography
        ref={textRef}
        onClick={onClick}
        variant={variant}
        component={component}
        sx={(theme) => ({
          ...theme.mixins.overflow,
          //   display: "-webkit-box",
          //   WebkitLineClamp: lines, // number of lines to show
          //   WebkitBoxOrient: "vertical",
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
          cursor: showTooltip ? "pointer" : "inherit",
          maxWidth: "100%", // dynamic width (fit parent)
          ...sx,
        })}
      >
        {children}
      </Typography>
    </CustomTooltip>
  );
};

export default OverflowTooltip;
